<template>
  <b-row>
    <b-col cols="12" class="mt-4">
      <div class="titlePage mb-3">Cargos e Provas Objetivas Definidos</div>
    </b-col>
    <b-col cols="12" class="mb-2">
      <fcc-button
        icon="trash-alt"
        class="mr-2"
        @click="deletaCargoProvaDefinido"
        :disabled="temExportacao"
      >
        Deletar
      </fcc-button>
      <fcc-button icon="file-export" @click="exportaCargoProvaDefinido" :disabled="temExportacao">
        Exportar
      </fcc-button>
    </b-col>
    <b-col cols="12">
      <fcc-table
        striped
        hover
        :por-page="'100'"
        pagination
        :fields="fieldsCargosProvasDefinidos"
        :items="lstConfigFinal"
        responsive
        :mostrarQuantidade="false"
      />
    </b-col>
  </b-row>
</template>
<script>
import axios from 'axios'
import store from '@/store'
export default {
  data() {
    return {
      fieldsCargosProvasDefinidos: [
        { key: 'idfolha', label: 'Folha', sortable: true },
        { key: 'codcargo', label: 'Cod_Opcao', sortable: true },
        { key: 'provas', label: 'Provas', sortable: true },
        { key: 'tecnico', label: 'Técnico', sortable: true },
        { key: 'dataconfiguracaofim', label: 'Data da Configuração', sortable: true }
      ]
    }
  },
  mounted() {
    this.baseUrlPublicacao = store.state.baseUrlPublicacao
  },
  props: {
    idNotificacao: String,
    lstConfigFinal: Array,
    temExportacao: Boolean
  },
  methods: {
    deletaCargoProvaDefinido() {
      this.callConfirm(`Tem certeza que deseja deletar?`, '').then(() => {
        axios
          .put(
            this.baseUrlPublicacao + 'PublicacaoGabarito/DeleteCargoProva',
            this.lstConfigFinal,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.$emit('listarConfiguracaoFinal')
            this.callToast(this.mensagensUpdate.editado)
          })
          .catch(this.setErrorSystem)
          .finally(this.carregaTexto())
      })
    },
    exportaCargoProvaDefinido() {
      this.callConfirm(`Tem certeza que deseja exportar?`, '').then(() => {
        this.carregaTexto(this.codeMensagem('C03'))
        axios
          .post(
            this.baseUrlPublicacao + 'PublicacaoGabarito/Exportar',
            this.idNotificacao,
            this.dadosLoginSession.fccTokenHeaders
          )
          .then(() => {
            this.carregaTexto()
            this.$emit('listarExportacao')
            this.callToast('Sucesso ao Exportar!')
          })
          .catch((error) => {
            this.carregaTexto()
            this.setErrorSystem(error)
          })
      })
    }
  }
}
</script>